module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/sp-txt-closed-f12e6b3968b3f0537bcc2ef4d6348d99.png";